(() => {
  const dialog = document.getElementById('SesseqLaunchDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const description = dialog.querySelector('#SesseqLaunchDescription');
  const productName = dialog.querySelector('[data-sesseq-notify-product-name]');
  const generalPanel = dialog.querySelector('[data-sesseq-general-panel]');
  const productPanel = dialog.querySelector('[data-sesseq-product-panel]');
  const productForm = dialog.querySelector('#SesseqProductLaunchForm');
  const storageKey = 'sesseq-product-interest';
  let trigger;
  let selectedProduct = null;
  const selectProduct = (product) => {
    selectedProduct = product;
    generalPanel.hidden = Boolean(product);
    productPanel.hidden = !product;
    productName.hidden = !product;
    productName.textContent = product ? product.title + (product.variantTitle && product.variantTitle !== 'Default Title' ? ' · ' + product.variantTitle : '') : '';
    description.textContent = product ? description.dataset.productDescription : description.dataset.generalDescription;
    productForm.querySelectorAll('[data-notify-field]').forEach((field) => {
      field.value = product?.[field.dataset.notifyField] || '';
    });
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-sesseq-notify]');
    if (!opener) return;
    event.preventDefault();
    trigger = opener;
    let product = null;
    if (opener.dataset.sesseqProductId) {
      const section = opener.closest('section, .shopify-section');
      const picker = section?.querySelector('variant-radios, variant-selects');
      const variant = picker?.currentVariant;
      const variantId = variant?.id || opener.dataset.sesseqVariantId || '';
      const url = new URL(opener.dataset.sesseqProductUrl, window.location.origin);
      if (variantId) url.searchParams.set('variant', variantId);
      product = {
        id: opener.dataset.sesseqProductId,
        handle: opener.dataset.sesseqProductHandle,
        title: opener.dataset.sesseqProductTitle,
        variantId: String(variantId),
        variantTitle: variant?.title || opener.dataset.sesseqVariantTitle || '',
        url: url.href
      };
    }
    selectProduct(product);
    if (!dialog.open) dialog.showModal();
    (product ? productPanel : generalPanel).querySelector('input[type="email"]')?.focus();
  });
  productForm.addEventListener('submit', () => {
    if (!selectedProduct) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify(selectedProduct)); } catch {}
  });
  dialog.querySelector('[data-sesseq-notify-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { if (trigger?.isConnected) trigger.focus(); });
  let previousProduct = null;
  try { previousProduct = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
  const productResult = productPanel.querySelector('[data-sesseq-product-result]');
  if (productResult && previousProduct && window.location.hash === '#SesseqProductLaunchForm') {
    selectProduct(previousProduct);
    dialog.showModal();
    if (productResult.dataset.sesseqProductResult === 'success') {
      try { sessionStorage.removeItem(storageKey); } catch {}
    }
  } else if (generalPanel.querySelector('[data-sesseq-notify-result]') && window.location.hash === '#SesseqLaunchForm') {
    selectProduct(null);
    dialog.showModal();
  }
})();
